<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div
        class="bg-img-hero"
        style="
          background-image: url(assets/svg/components/abstract-shapes-12.svg);
        "
      >
        <div class="container space-top-2 space-top-lg-3 space-bottom-2">
          <div class="w-md-80 w-lg-60 text-center mx-md-auto">
            <h1>是否有更多疑问？</h1>
            <p>
              我们希望获得您对产品的反馈，以便我们能够更好的提升产品及服务品质
            </p>
          </div>
        </div>
      </div>
      <!-- End Hero Section -->

      <!-- Hire Us Form Section -->
      <div class="container space-2 space-bottom-lg-3">
        <el-form class="row justify-content-lg-center" :model="form" ref="form" rules="rule">
          <div class="col-lg-8">
            <!-- Input -->
            <div class="mb-4 mb-md-6">
              <label class="input-label">您的名字</label>
              <el-form-item prop="name">
                <el-input
                type="text"
                class="form-control"
                placeholder="CLTC"
                required
                v-model="form.name"
              />
              </el-form-item>
              
            </div>
            <!-- End Input -->

            <!-- Input -->
            <div class="js-form-message mb-4 mb-md-6">
              <label class="input-label">您的邮件</label>
              <el-form-item prop="email">
                <el-input
                type="email"
                class="form-control"
                placeholder="web@cltc.info"
                required
                v-model="form.email"
              />
              </el-form-item>
              
            </div>
            <!-- End Input -->

            <!-- Input -->
            <div class="mb-4 mb-md-6">
              <label class="input-label"
                >您的疑问<span class="text-muted font-weight-normal ml-1"
                  >(选填)</span
                ></label
              >
                 <el-input
                  type="text"
                  v-model="form.question"
                  class="form-control"
                  placeholder="填写疑问标题"
                />
             
            </div>
            <!-- End Input -->
              <label class="input-label"
                >您的疑问产品<span class="text-muted font-weight-normal ml-1"
                  >(选填)</span
                ></label>
            <el-radio-group v-model="form.product">
              <el-radio label="数据可视化">数据可视化</el-radio>
              <el-radio label="系统集成">系统集成</el-radio>
              <el-radio label="其他产品或业务">其他产品或业务</el-radio>
            </el-radio-group>
            <!-- Platform -->
            <!-- End Platform -->
            <!-- Input -->
            <div class="js-form-message mb-4 mb-md-6">
              <label class="input-label">您对于疑问问题的描述</label>
              <textarea
                class="form-control"
                rows="4"
                v-model="form.message"
                placeholder="这里,输入您要的内容..."
                required
              ></textarea>
            </div>
            <!-- End Input -->

            <div class="text-center">
              <div class="mb-2">
                <button @click="submit()" class="btn-primary" style=" border:1px solid transparent;
                border-radius:0.2rem;padding: 0.25rem 0.5rem;font-size: 0.875rem;line-height: 1.5;
                background-color: #377dff;
                border-color: #377dff;" >提交问题</button>
              </div>
              <p class="small">收到问题后我们将尽快与您获得联系</p>
            </div>
          </div>
        </el-form>
      </div>
      <!-- End Hire Us Form Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //9
import "@/assets/js/hs.validation.js"; //11

import "@/assets/vendor/font-awesome/css/all.min.css"; //12
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //13
import "@/assets/css/theme.css"; //14
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3

import "@/assets/js/hs.core.js"; //10
import Header from "../components/header";
import Footer from "../components/footer";
import {validEmail} from '../utils/validate'
import {addhelp} from '../request/index'
export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    $(document).ready(function () {
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  data(){
    var checkEmail = (rule, value, callback) =>{
      if(!value){
        return callback(new Error('邮箱不能为空'));
      }else{
        if(!validEmail(value)){
            return callback(new Error('邮箱格式不对'));
        }else{
          callback()
        }
      }
    }
    return{
      form:{
        name:null,email:null,question:null,product:null,message:null
      },
      list:[
        {value:'数据可视化',ckeck:true},
        {value:'系统集成 ',ckeck:false},
        {value:'其它产品或业务',ckeck:false},
      ],
      rulus:{
        name:[{required:true,message:'请填写您的姓名',trigger: 'blur'}],
        email:[{validator: checkEmail, trigger: 'blur'}]
      }
    }
  },
  methods:{
    submit(){
       this.$refs.form.validate((val)=>{
         if(val){
           console.log(this.form)
            let data = {hemail:this.form.email,hmessage:this.form.message,hname:this.form.name,hproduct:this.form.product,hquestion:this.form.question}
             addhelp(data).then(res=>{
              console.log(res)
              if(res.status == 201){alert('提交成功');this.form={ name:null,product:null,email:null,message:null,question:null}}
            }).catch(err=>{alert('提交失败')})
         }else{
           return
         }
       })
   
       
      
    },
    getValue(obj,i){
     console.log(obj,i)
    }
  }
};
</script>

<style scoped>
.bg-img-hero {
  background: url("../assets/svg/components/abstract-shapes-12.svg");
}
.w-md-80 h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.w-md-80 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
</style>


// WEBPACK FOOTER //
// src/view/help.vue